export const hotlineTelNumber = "48 579779990";
export const hotlineTelNumber = "48 579779990";
